import jsCookie from 'js-cookie';

const LOGIN_KEY = 'sj_login';

function getCookieDomain() {
    const parts = window.location.hostname.split('.');
    if (parts.length > 2) {
        return `.${parts.slice(-2).join('.')}`;
    }
    return window.location.hostname;
}

function getCookieDomains() {
    const hostname = window.location.hostname;
    const rootDomain = getCookieDomain();
    const domains = ['', hostname, rootDomain];
    if (rootDomain.startsWith('.')) {
        domains.push(rootDomain.slice(1));
    }
    return [...new Set(domains)];
}

function isValidAuthToken(token) {
    if (!token || typeof token !== 'string') {
        return false;
    }
    const value = token.trim();
    if (!value || value === '-' || value === 'null' || value === 'undefined') {
        return false;
    }
    return value.split('.').length === 3;
}

const UserUtil = {
    isValidAuthToken,

    /** 保存登录信息到 localStorage */
    saveLogin(userNum, token) {
        if (!userNum || !isValidAuthToken(token)) {
            this.clearTokenCookies();
            return false;
        }
        try {
            localStorage.setItem(LOGIN_KEY, JSON.stringify({ userNum, token, time: Date.now() }));
        } catch (e) { /* ignore */ }
        try {
            const cookieOptions = { path: '/', domain: getCookieDomain(), expires: 30 };
            jsCookie.set('token', token, cookieOptions);
            jsCookie.set('userNum', userNum, cookieOptions);
        } catch (e) { /* ignore */ }
        return true;
    },

    /** 从 localStorage 读取登录信息 */
    getStoredLogin() {
        try {
            const raw = localStorage.getItem(LOGIN_KEY);
            if (raw) {
                const data = JSON.parse(raw);
                // 登录有效期 30 天
                if (data.time && Date.now() - data.time < 30 * 24 * 60 * 60 * 1000) {
                    if (!isValidAuthToken(data.token)) {
                        localStorage.removeItem(LOGIN_KEY);
                        return null;
                    }
                    return data;
                }
                // 过期则清除
                localStorage.removeItem(LOGIN_KEY);
            }
        } catch (e) { /* ignore */ }
        return null;
    },

    clearTokenCookies() {
        try {
            localStorage.removeItem('token');
            getCookieDomains().forEach(domain => {
                const options = domain ? { path: '/', domain } : { path: '/' };
                jsCookie.remove('token', options);
                jsCookie.remove('userNum', options);
                jsCookie.remove('JSESSIONID', options);
            });
        } catch (e) { /* ignore */ }
    },

    /** 清除登录信息 */
    clearLogin() {
        try {
            localStorage.removeItem(LOGIN_KEY);
            localStorage.removeItem('token');
        } catch (e) { /* ignore */ }
        this.clearTokenCookies();
    },

    getUserNum() {
        // 1. 优先从 URL 参数获取（分享链接等场景）
        const location = window.app && window.app.history && window.app.history.location
            ? window.app.history.location
            : window.location;
        const searchParams = new URLSearchParams(location.search);
        var userNum = searchParams.get("userNum");
        if (userNum) return userNum;

        // 2. 从 localStorage 获取持久化的登录状态
        const stored = this.getStoredLogin();
        if (stored && stored.userNum) return stored.userNum;

        return '';
    },
    biz(explicitBiz) {
        if (explicitBiz) {
            return explicitBiz;
        }
        const pathname = window.app && window.app.history && window.app.history.location 
            ? window.app.history.location.pathname 
            : window.location.pathname;
        
        if (pathname.includes("/write-live100")) {
            return 'live100'
        }
        if (pathname.includes("/write-live")) {
            return 'live'
        }
        if (pathname.includes("/write-read")) {
            return 'read'
        }
        if (pathname.includes("/write-article")) {
            return 'myArticle'
        }
        if (pathname.includes("/write-publish")) {
            return 'publish'
        }
        return (window.app && window.app.biz) || 'yuxie';
    },
    avatarUrl(url) {
        if (url) {

            if (!url.startsWith("http")) {
                return `/${url}?x-oss-process=image/resize,m_fill,h_128,w_128`
            }
        }
        return url;
    },
    isPublish() {
        const pathname = window.app && window.app.history && window.app.history.location 
            ? window.app.history.location.pathname 
            : window.location.pathname;
        return pathname.includes("/write-publish");
    },
    initSession() {
      const searchParams = new URLSearchParams(window.location.search);
      let hostArr = window.location.host.split('.');
      hostArr = hostArr.length === 2 ? hostArr.join('.') : hostArr.slice(1).join('.')
      if (searchParams.get("JSESSIONID")) {
          jsCookie.remove('JSESSIONID')
          jsCookie.set('JSESSIONID', searchParams.get("JSESSIONID"), {path: "/", domain: hostArr});
      }
      if (searchParams.get("tn")) {
          const token = searchParams.get("tn");
          if (!isValidAuthToken(token)) {
              this.clearTokenCookies();
              return;
          }
          jsCookie.remove('token')
          jsCookie.set('token', token, {path: "/", domain: hostArr});
          // 持久化 token
          const userNum = searchParams.get("userNum") || this.getStoredLogin()?.userNum;
          if (userNum) {
              this.saveLogin(userNum, token);
          }
          if(window.app && window.app.history){
            searchParams.delete('tn');
            const newSearch = searchParams.toString();
            const location = window.app.history.location;
            window.app.history.replace({
                pathname: location.pathname,
                search: newSearch ? `?${newSearch}` : '',
                hash: location.hash
            });
          }
      }
      // 如果 URL 中有 userNum 但没有 token，也保存登录状态
      const urlUserNum = searchParams.get("userNum");
      const urlToken = searchParams.get("tn") || jsCookie.get("token");
      if (urlUserNum && isValidAuthToken(urlToken)) {
          this.saveLogin(urlUserNum, urlToken);
      }
    }
}
export default UserUtil;
